import React,{useMemo} from "react";
import _ from "lodash";
import { List, ListItem, Card, CardContent, Stack, Typography, Link, Rating,Drawer,useTheme,styled,Chip, IconButton, Avatar, DialogTitle, MenuItem, Select } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { getNumeric } from "../../../../common/utils";
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { Close, Group } from "@mui/icons-material";
import GroupedChip from "./groupedChip";
import { grey } from "@mui/material/colors";
const StyledChip = styled(Chip)({
    borderRadius: '6px',
})

const shouldCollapseFunc = (namespace, data, level) => {
  
    return Array.isArray(data) && level >= 2;
};

const SelectedIdSB = ({open=false,handleClose,selectedId=null,selectedPlaceId,resultsMemo,selectedLocationFalconData}) => {
    const [sortedBy, setSortedBy] = React.useState('solv|desc')
    const allData = useMemo(() => {
        let data = selectedLocationFalconData?.parsedOutput?.data.results;
        return _.flatMapDepth(data, it => { return it.results })
    }, [selectedLocationFalconData]);
    
    const groupedAllData = useMemo(() => {
        return _.groupBy(allData, 'place_id')
    },[allData])
    const getFoundValue = (item) => {
        let value = 0
        const gridSize=(resultsMemo.length??0)
        _.map(resultsMemo, it => {
            if (_.find(it.results, { place_id: item })) {
                value++
            }
        })
        return `${value}/${gridSize} (${value === 0 ? "0%" : getNumeric(value / gridSize * 100, true)}%)`
    }
    const compareId = (item) => {
        
        return item === selectedPlaceId
    }
    const getSummaryOfPlace = (place_id) => {
        const points = selectedLocationFalconData?.parsedOutput?.data?.points
        let totalFound = groupedAllData[place_id]?.length;
        let presenceTop3Rank =  _.filter(groupedAllData[place_id], it=>{ return it.rank <= 3})?.length ?? 0;
        let presence = _.sumBy(groupedAllData[place_id], 'rank');
        let totalRank = presence + ((points - totalFound) * 21);
        return {
            solv: presenceTop3Rank > 0 ? (presenceTop3Rank / points) * 100 : 0,
            arp: (presence / points),
            atrp: (totalRank / points)
        }
    
    }
 const theme=useTheme()
 const listData=useMemo(()=>{
    let tempArr=[]
    if(selectedId?.results){
        tempArr=selectedId?.results
    }
    else{
        tempArr=_.uniqBy(allData, 'place_id')
    }
    const tempArr2=_.map(tempArr, it =>{ 
        const summaryObj=getSummaryOfPlace(it.place_id)
        const arp=getNumeric(summaryObj.arp,true)
        const atrp=getNumeric(summaryObj.atrp,true)
        const solv=summaryObj.solv
      return  ({...it,arp,atrp,solv})
    })
    const orderByArr=selectedId?['rank','asc']:sortedBy?.split('|')
    return _.orderBy(tempArr2,orderByArr[0],orderByArr[1])
 },[allData,selectedId,sortedBy])
 return <Drawer open={open} onClose={handleClose} variant="temporary" slotProps={{backdrop:{invisible:true}}} anchor="right" sx={{height:'100%',maxWidth:'300px','& .MuiDrawer-paper':{top:'144px',boxShadow:'none',borderLeft:'1px solid',borderColor:theme=>theme.palette.divider}}}>
    <DialogTitle component={'div'} sx={{p:'8px 24px',display:'flex',alignItems:'center',justifyContent:'space-between',pb:0}}>
        <Typography fontWeight={500} fontSize={'1rem'}>{selectedId?`Businesses in ${selectedId?.lat},${selectedId?.lng}`:'All businesses'}</Typography>
        {!selectedId &&<Stack direction='row' spacing={1}  alignItems={'center'}>
            <Typography>Sorted on:</Typography>
             <Select sx={{width:'160px'}} size="small" value={sortedBy} onChange={e=>setSortedBy(e.target.value)}>
            <MenuItem value={'solv|desc'}>Presence</MenuItem>
            <MenuItem value={'arp|asc'}>Presence Rank</MenuItem>
            <MenuItem value={'atrp|asc'}>Total Rank</MenuItem>
            </Select>
            </Stack>}
    </DialogTitle>
    <List sx={{ flex: 1, overflowY: 'auto', width: '100%',marginBottom:'144px',pt:0 }}>
  {_.map(_.clone(listData), (it, index) => {
    
      return <ListItem key={it.place_id} sx={{ width: '100%'}}>
          <Card  sx={{ border: '1px solid', borderColor: theme.palette.divider, width: '100%',p:'0px'}}>
              <CardContent>
                <Stack alignItems={'center'} direction={'row'} spacing={1} ml={-1}>
                    <Avatar sx={{width:'32px',height:'32px',bgcolor:'#D9EDFD',color:grey[700],fontSize:'1rem'}}>{(index+1)>99?'99+':index+1}</Avatar>
                      <Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'space-between'}>
                          <div>
                              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                  {!compareId(it.place_id) ? <Typography sx={{maxWidth:'210px'}} variant='body1' fontWeight={500} fontSize={'1rem'} noWrap whiteSpace={'nowrap'} textOverflow={'ellipses'}>{it?.business}</Typography> : <StyledChip label={it?.business} color='success' size='small' />}
                                  <Link href={it?.map_url} target='_blank'><OpenInNewIcon fontSize='small' sx={{ mt: 0.6 }} /></Link>
                                  <Stack direction={'row'} spacing={2} alignItems={'center'}>
                                    <span style={{display:'flex',gap:'4px', alignItems:'center'}}>
                                  <Typography fontStyle={'italic'}>{it?.reviews} {it?.reviews !== 1 ? "reviews" : 'review'}</Typography>
                                  <Stack direction={'row'} fontSize={'14px'}>({it?.rating??0}<StarOutlineIcon sx={{fontSize:'16px',mt:0.2}} />)</Stack>
                                  </span>
                              </Stack>
                              </div>
                              <Typography fontStyle={'italic'} noWrap whiteSpace={'nowrap'} textOverflow={'ellipses'} sx={{maxWidth:'428px'}}>{it?.address}</Typography>
                              <Stack direction={'row'} spacing={1} alignItems={'center'} pt={1}>
                                {/* <GroupedChip mainText='Found' secondaryText={getFoundValue(it.place_id)} size='small'/> */}
                                <GroupedChip mainText='Presence' secondaryText={`${getNumeric(it?.solv,true)}%`} size='small'/>
                                <GroupedChip mainText='Presence Rank' secondaryText={it?.arp} size='small'/>
                                <GroupedChip mainText='Total Rank' secondaryText={it?.atrp} size='small'/>
                              </Stack>
                              
                         </div>
 

                     </Stack>   
                     </Stack>             
              </CardContent>
          </Card>
      </ListItem>
  })}
  </List>
  </Drawer>
};

export default SelectedIdSB;
